export default __webpack_public_path__ + "static/media/allgemein_13.15c71cf8.jpg";